import { render, staticRenderFns } from "./BackgroundImg.vue?vue&type=template&id=9b6fed86"
import script from "./BackgroundImg.vue?vue&type=script&lang=js"
export * from "./BackgroundImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports